var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.914 19.715 2 12.605l1.836-1.835 5.078 5.195 11.25-11.68L22 6.043 8.914 19.715Z",
    fill: "#141414"
  })));
};
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjkxNDA2IDE5LjcxNDhMMiAxMi42MDU1TDMuODM1OTQgMTAuNzY5NUw4LjkxNDA2IDE1Ljk2NDhMMjAuMTY0MSA0LjI4NTE2TDIyIDYuMDQyOTdMOC45MTQwNiAxOS43MTQ4WiIgZmlsbD0iIzE0MTQxNCIvPgo8L3N2Zz4K";